module.exports = require("skeletos");


//////////////////
// WEBPACK FOOTER
// external "skeletos"
// module id = 0
// module chunks = 0 1